import React from "react";
import { Box, Typography, Grid, Paper } from "@mui/material";
import { Link } from "react-router-dom";
import RIMCLogo from "../assets/RIMCLogo.jpg";
import RMSLogo from "../assets/RMS.jpeg";
import SainikLogo from "../assets/SainikLogo.jpg";
import NavodayaLogo from "../assets/NavodayaLogo.png";

const programs = [
  {
    title: "Navodaya",
    icon: (
      <Box
        component="img"
        src={NavodayaLogo}
        alt="Navodaya Logo"
        sx={{
          width: 60,
          height: 60,
          objectFit: "contain",
          borderRadius: "8px",
        }}
      />
    ),
    description:
      "Focused preparation for Jawahar Navodaya Vidyalaya entrance exams with expert mentors and curated materials.",
    link: "/navodaya",
  },
  {
    title: "RIMC",
    icon: (
      <Box
        component="img"
        src={RIMCLogo}
        alt="RIMC Logo"
        sx={{
          width: 60,
          height: 60,
          objectFit: "contain",
          borderRadius: "8px",
        }}
      />
    ),
    description:
      "Special coaching for Rashtriya Indian Military College with mock tests, subject mastery, and interview guidance.",
    link: "/RIMC",
  },
  {
    title: "Sainik",
    icon: (
      <Box
        component="img"
        src={SainikLogo}
        alt="Sainik Logo"
        sx={{
          width: 60,
          height: 60,
          objectFit: "contain",
          borderRadius: "8px",
        }}
      />
    ),
    description:
      "Complete Sainik School entrance coaching including subject-wise classes and personality development.",
    link: "/sainik",
  },
  {
    title: "Military",
    icon: (
      <Box
        component="img"
        src={RMSLogo}
        alt="RMS Logo"
        sx={{
          width: 60,
          height: 60,
          objectFit: "contain",
          borderRadius: "8px",
        }}
      />
    ),
    description:
      "Targeted sessions for Military School admission with detailed subject coverage and physical readiness tips.",
    link: "/military",
  },
];

const SchoolPrograms = () => {
  return (
    <Box sx={{ py: 6, mt: 3, backgroundColor: "#F3F9FF", textAlign: "center" }}>
      <Typography
        variant="h4"
        sx={{
          display: "inline-block",
          fontFamily: "Poppins, sans-serif",
          fontOpticalSizing: "auto",
          fontStyle: "normal",
          letterSpacing: 1,
          color: "#065A79",
          fontWeight: "bold",
        }}
      >
        Our Special Programs
      </Typography>

      <Box sx={{ ml: 2.5, mr: 2.5 }}>
        <Grid container spacing={4} justifyContent="center" sx={{ mt: 2 }}>
          {programs.map((program, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Link
                to={program.link}
                target="_self"
                style={{ textDecoration: "none" }}
              >
                <Paper
                  elevation={4}
                  sx={{
                    p: 3,
                    height: "100%",
                    borderRadius: 3,
                    textAlign: "center",
                    position: "relative",
                    background: "linear-gradient(135deg, #065A79, #AD1C86)",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 2,
                      left: 2,
                      right: 2,
                      bottom: 2,
                      borderRadius: 3,
                      backgroundColor: "white",
                      zIndex: 1,
                    },
                    "& > *": {
                      position: "relative",
                      zIndex: 2,
                    },
                    transition:
                      "transform 0.5s ease, box-shadow 0.5s ease, background-color 0.5s ease",
                    "&:hover": {
                      transform: "scale(1.05)",
                      boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.2)",
                      cursor: "pointer",
                    },
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 70 }}>
                    {program.icon}
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{
                      mt: 2,
                      fontWeight: "bold",
                      fontFamily: "Montserrat, sans-serif",
                      fontOpticalSizing: "auto",
                      fontStyle: "normal",
                      letterSpacing: 1,
                      color: "#AD1C86",
                    }}
                  >
                    {program.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      mt: 1,
                      fontFamily: "Montserrat, sans-serif",
                      fontOpticalSizing: "auto",
                      fontStyle: "normal",
                      letterSpacing: 1,
                      lineHeight: "1.8rem",
                    }}
                  >
                    {program.description}
                  </Typography>
                </Paper>
              </Link>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default SchoolPrograms;